
import { axiosPost } from '../utilities/axiosRequest';
import { transactionLog } from "../apiEndPoints";

export function logTransaction(serviceName, json, pid = null) {
    return function (dispatch, getState) {
        let url = transactionLog;
        let user = getState().login.user;
        // let userId = user?.profileForUser !== undefined ? (user?.profileForUser[0]?.portalUserId ? user?.profileForUser[0]?.portalUserId : user?.profileForUser[0]?.id) : null;
        // let userType = user?.profileForUser !== undefined ? (user?.profileForUser[0]?.portalUserId ? "DASHBOARDUSER" : "CONSULTANT") : "";
        let data = {
            "serviceName": serviceName,
            "serviceInput": JSON.stringify(json),
            // "uniqueId": userId,
            // "createrType": userType,
            "mobileNo": "",
            "source": "Dashboard",
            // "appVersion": `v${appVersion}-cp.${codepushVersion}`,
            "appVersion": "",
        }
        if (pid !== null) {
            data.patientId = pid;
        }

        axiosPost(url, data)
            .then(response => {
                console.log("response hereee", response)
                if (response.status == 200) {
                    console.log('transaction sent to the backend');
                    console.log(response);
                }
                else {
                    console.log('failed to send transaction to the backend');
                    console.log(response);
                }
            })
            .catch(err => {
                console.log('failed to send transaction to the backend');
                console.log(err);
            })
    }
}